import api from '@/utils/api';
import payment from './payrollPaymentPresentation';

export default {
    props: {request: {type: Object, required: true}, blockedReason: {type: String, default: ''}},
    data: () => ({rows: [], details: null, correcting: false, loading: false, busy: false, error: '', baseline: '[]', requestId: 0, closing: false}),
    computed: {
        title() { return this.request.lineId ? 'Фактическая выплата' : 'Зафиксировать выплату'; },
        dirty() { return JSON.stringify(this.rows) !== this.baseline; },
        totals() {
            const totals = new Map();
            this.rows.forEach(row => {
                const total = totals.get(row.currency) || {currency: row.currency, approved: 0, actual: 0, valid: true};
                const amount = payment.parse(row.amount);
                total.approved += row.approved; total.actual += amount || 0; total.valid = total.valid && amount != null;
                totals.set(row.currency, total);
            });
            return Array.from(totals.values());
        }
    },
    watch: {dirty(value) { this.$emit('dirty', value); }},
    created() {
        if (this.request.lineId) this.load();
        else {
            this.rows = this.request.lines.map(line => ({id: line.id, name: line.employee_name_snapshot,
                currency: line.currency || line._currency, approved: line.approved_amount_minor,
                amount: payment.input(line.approved_amount_minor), comment: '', revision: line.payment_revision}));
            this.baseline = JSON.stringify(this.rows);
        }
    },
    beforeDestroy() { this.requestId++; },
    methods: {
        money: payment.money, difference: payment.difference,
        delta(row) { const amount = payment.parse(row.amount); return amount == null || row.approved == null ? null : amount - row.approved; },
        date(value) { return value ? `${new Date(value).toLocaleString('ru-RU', {timeZone: 'Etc/GMT-3'})} · UTC+3` : 'Нет данных'; },
        originLabel(origin) { return {legacy_event: 'Прежний способ фиксации: сумма из сохранённого события выплаты.', legacy_statement: 'Прежний способ фиксации: сумма из переданной ведомости.', unknown: 'Сумма прежней выплаты не сохранена.'}[origin] || 'Факт выплаты ещё не зафиксирован.'; },
        async load() {
            const id = ++this.requestId; this.loading = true; this.error = '';
            try { const response = await api.get(`/api/payroll/lines/${this.request.lineId}/payment`, {ignoreModal: true}); if (id === this.requestId) this.details = response.data; }
            catch (error) { if (id === this.requestId) this.handleError(error); }
            finally { if (id === this.requestId) this.loading = false; }
        },
        beginCorrection() {
            const info = this.details; this.correcting = true;
            this.rows = [{id: info.line_id, name: info.employee_name, currency: info.currency, approved: info.approved_amount_minor,
                amount: payment.input(info.actual_amount_minor), comment: '', revision: info.payment_revision}];
            this.baseline = JSON.stringify(this.rows);
        },
        onHide(event) { event.preventDefault(); this.requestClose(); },
        async requestClose() {
            if (this.busy || this.closing) return;
            this.closing = true;
            try {
                if (this.dirty && !await this.$bvModal.msgBoxConfirm('Есть несохранённые изменения. Перейти без сохранения?', {title: 'Несохранённые изменения', okTitle: 'Перейти без сохранения', cancelTitle: 'Остаться', okVariant: 'danger'})) return;
                this.$emit('close');
            } finally { this.closing = false; }
        },
        handleError(error) {
            this.error = error.response && error.response.data && error.response.data.msg || 'Не удалось сохранить или загрузить выплату. Повторите действие.';
            if (error.response && [401, 403].includes(error.response.status)) { this.rows = []; this.details = null; this.$emit('forbidden'); }
        },
        async save() {
            if (this.blockedReason) { this.error = this.blockedReason; return; }
            if (this.busy || !this.rows.length) return;
            this.error = '';
            const invalid = this.rows.find(row => payment.parse(row.amount) == null || row.approved == null || !row.revision);
            if (invalid) { this.error = `${invalid.name}: укажите сумму от нуля с точностью до копеек. Если утверждённая сумма недоступна, обновите ведомость.`; return; }
            if (this.correcting && !this.rows[0].comment.trim()) { this.error = 'Укажите причину исправления фактической выплаты.'; return; }
            const payments = this.rows.map(row => ({line_id: row.id, actual_amount_minor: payment.parse(row.amount), comment: row.comment.trim(), expected_payment_revision: row.revision}));
            const id = ++this.requestId; this.busy = true; this.$emit('busy', true);
            try {
                if (this.correcting) await api.patch(`/api/payroll/lines/${this.request.lineId}/payment`, {...payments[0], reason: payments[0].comment}, {ignoreModal: true});
                else await api.post(`/api/payroll/periods/${this.request.periodId}/pay-lines`, {payments}, {ignoreModal: true});
                if (id === this.requestId) { this.baseline = JSON.stringify(this.rows); this.$emit('saved'); }
            } catch (error) { if (id === this.requestId) this.handleError(error); }
            finally { if (id === this.requestId) { this.busy = false; this.$emit('busy', false); } }
        }
    }
};
